import { render } from "./Header.vue?vue&type=template&id=5531d17f"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=5531d17f&lang=css"
script.render = render

export default script